import React from 'react';
import {
  Create,
  SimpleForm,
  SaveButton,
  Toolbar, TextInput
} from 'react-admin';
import {Box, Card, CardContent, makeStyles, Typography} from '@material-ui/core';
import LogicInput from './logicInput';
import {authorized} from "../../authorized";

const useStyles = makeStyles(theme => ({
  root: {
    display: 'flex',
    flexDirection: 'column',
    [theme.breakpoints.up('md')]: {
      flexDirection: 'row',
    },
  },
  form: {
    flex: 1,
    marginRight: 0,
    [theme.breakpoints.up('md')]: {
      marginRight: theme.spacing(2),
    },
  },
  preview: {
    width: '100%',
    [theme.breakpoints.up('md')]: {
      width: '350px',
    },
  },
  section: {
    marginBottom: theme.spacing(3),
  },
  sectionTitle: {
    color: theme.palette.primary.main,
    marginBottom: theme.spacing(2),
    fontWeight: 600,
  },
  toolbar: {
    display: 'flex',
    justifyContent: 'space-between',
    alignItems: 'center',
    padding: 0,
  }
}));

const CustomToolbar = props => {
  const classes = useStyles();

  if (authorized.permissions.indexOf('product.qr_codes.create') === -1) {
    return (<span/>)
  }
  
  return (
    <Toolbar {...props} className={classes.toolbar}>
      <SaveButton label="Create QR Code" />
    </Toolbar>
  );
};

const QrCodeCreate = (props) => {
  const classes = useStyles();
  
  // Generate current date for created_at field
  const now = new Date();
  const defaultValues = {
    created_at: now.toISOString(),
    logic: {
      logic_android: '',
      logic_ios: '',
      logic_web: ''
    }
  };

  return (
      <Card>
        <CardContent>
          <Create {...props} title="Create New QR Code">
            <SimpleForm
                className={classes.form}
                initialValues={defaultValues}
                toolbar={<CustomToolbar />}
                redirect="show"
            >
              <Box className={classes.field}>
                <Typography className={classes.fieldLabel} variant="h6">Name</Typography>
                <Typography className={classes.fieldValue}>
                  <TextInput source="name" fullWidth/>
                </Typography>
              </Box>
              <LogicInput />
            </SimpleForm>
          </Create>
        </CardContent>
      </Card>
  );
};

export default QrCodeCreate;